import { ProductDocsWidget } from '../../widgets/ProductDocsWidget';
import { SiteRoute } from '@journeyapps/package-types';
import * as React from 'react';
import styled from '@emotion/styled';
import { PageWidget } from '../../widgets/layout/PageWidget';
import { ContentWidget } from '../../widgets/ContentWidget';
import { CrumbWidget } from '../../widgets/CrumbWidget';
import { SectionWidget } from '../../widgets/layout/SectionWidget';
import { Link } from 'react-router';
import { PHONE_MEDIA } from '../../vars';

const image = require('../../../media/elementor-placeholder-image.png');
const image_integrations = require('../../../media/stack/integrations.png');
const image_scale = require('../../../media/stack/scalability.png');
const image_external_packages = require('../../../media/stack/external-packages.png');
const image_database_orm = require('../../../media/stack/database-orm.png');
const image_cloudcode_tasks = require('../../../media/stack/cloudcode-tasks.png');

export const CloudCodePage: React.FC = (props) => {
  return (
    <PageWidget width={1100} title="CloudCode">
      <ContentWidget>
        <h1>
          <CrumbWidget parts={['Platform stack', 'CloudCode']} />
        </h1>
        {/*<S.Image src={image_integrations} />*/}
        <p>
          CloudCode runs JavaScript and TypeScript tasks on the server to automate business processes and connect
          systems. Use it to synchronize records, generate reports, or process incoming requests, with or without an app
          interface.
        </p>
        <p>
          Run tasks on a schedule, respond to data changes, or expose HTTP endpoints for external callers. Tasks can
          also be called directly from <Link to={SiteRoute.RUNTIME_ENGINE}>Runtime apps</Link> or other CloudCode tasks,
          so the same project can support interactive applications and automated workflows.
        </p>
        <SectionWidget
          zoom={false}
          image={image_integrations}
          label={'Build any kind of integration'}
          content="CloudCode tasks are Node.js programs written in JavaScript or TypeScript, allowing for infinite integration possibilities.
          With CloudCode, developers can extend the capabilities of their applications into the cloud, allowing them to securely connect to any external API."
          index={1}
        ></SectionWidget>
        <SectionWidget
          image={image_database_orm}
          ltr={false}
          label={'Direct access to the App Backend database'}
          content="Much like the runtime, CloudCode tasks can directly access the backend database using the identical ORM made available
          in apps built on top of the Runtime Engine."
          index={2}
        ></SectionWidget>
        <SectionWidget
          image={image_external_packages}
          label={'Bring your own libraries or external packages'}
          content="CloudCode tasks are Node.js programs, and with OXIDE, developers can directly add external dependencies with control over their version ranges."
          index={3}
        ></SectionWidget>
        <h2>Manage execution as your workloads grow</h2>
        <p>
          CloudCode runs tasks in parallel and queues work for processing. Use single-instance execution or named queues
          when operations need to run in sequence. From scheduled integrations to report generation, you can manage
          execution and investigate problems from OXIDE.
        </p>
        <S.ImageScale src={image_scale} />
        <h3>Monitor and control your tasks</h3>
        <ul>
          <li>Search invocation history and inspect logs to understand individual executions.</li>
          <li>Inspect queued and scheduled work for each deployment.</li>
          <li>Pause and resume queues, or clear pending work when it is no longer needed.</li>
        </ul>
      </ContentWidget>
      <SectionWidget
        image={image_cloudcode_tasks}
        label={'Deep integration with the backend'}
        content="Connecting a task to a model update/create/delete event is as easy as simply adding a single attribute in the schema. Once connected, developers
        can make use of reactive programming paradigms to post-process database changes in real-time as data changes. For example, send an email, delete related data or even trigger
        a deployment through the use of the platform's extensive operational APIs."
        index={1}
      ></SectionWidget>
      <ProductDocsWidget
        title="Build with CloudCode"
        description="Learn how to write, trigger, and extend your cloud tasks."
        topics={['CloudCode']}
      />
    </PageWidget>
  );
};
namespace S {
  export const Container = styled.div``;

  export const Image = styled.img`
    padding: 50px;
    box-shadow: none !important;
  `;

  export const ImageScale = styled.img`
    box-sizing: border-box;
    box-shadow: none !important;
    max-height: 300px !important;

    @media (max-width: ${PHONE_MEDIA}px) {
      min-width: 100%;
      max-width: 100%;
      transform: none;
    }
  `;
}
